import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogFooter,
} from "@/components/ui/alert-dialog";
import { checkStripeInvoice } from "@/services/api/Stripe";
import { Button } from "./ui/button";
import { useEffect, useState, useRef } from "react";

function ModalWaitPaymentUpgrade({ isModalOpen, setIsModalOpen, invoice, redirectTo }) {
  const [showCheckButton, setShowCheckButton] = useState(false);
  const intervalIdRef = useRef(null);
  const timeoutIdRef = useRef(null);
  const hourTimeoutIdRef = useRef(null);

  useEffect(() => {
    const checkPayment = async () => {
      const res = await checkStripeInvoice(invoice.id);
      const paymentStatus = res.data.data.status;
      if (paymentStatus === 'paid') {
        clearInterval(intervalIdRef.current);
        clearTimeout(timeoutIdRef.current);
        clearTimeout(hourTimeoutIdRef.current);
        return location.href = redirectTo;
      }
    };

    if (isModalOpen) {
      intervalIdRef.current = setInterval(checkPayment, 1000);

      timeoutIdRef.current = setTimeout(() => {
        clearInterval(intervalIdRef.current);
        setShowCheckButton(true);
      }, 30 * 60 * 1000); // 30 minutes

      hourTimeoutIdRef.current = setTimeout(() => {
        clearInterval(intervalIdRef.current);
        setIsModalOpen(false);
      }, 60 * 60 * 1000); // 1 hour
    }

    return () => {
      clearInterval(intervalIdRef.current);
      clearTimeout(timeoutIdRef.current);
      clearTimeout(hourTimeoutIdRef.current);
    };
  }, [isModalOpen, invoice.id, redirectTo]);

  const openPaymentLink = () => {
    const url = invoice.hosted_invoice_url;
    window.open(url, '_blank');
  };

  const formatCurrency = (amount, currency) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(amount / 100);
  };

  // Calculate the total amount to be paid
  const totalAmount = invoice.lines.data.reduce((total, line) => total + line.amount, 0);

  return (
    <AlertDialog open={isModalOpen}>
      <AlertDialogContent className="gap-0 p-0 bg-white text-background">
        <div className="p-4 pt-3 pb-0">
          <p className="text-lg font-semibold tracking-tight">
            Waiting for your payment to be completed
          </p>
        </div>
        <div className="p-4 py-2 overflow-y-auto max-h-[75vh] gap-x-3 gap-y-4">
          <p className="text-sm text-background/70">
            Please complete the payment to upgrade your subscription.
          </p>
          {/* <div className="p-4 bg-slate-300 my-4 rounded">
            <div className="flex flex-col justify-center text-center">
              <p className="text-xs text-slate-800">Payment Status</p>
              <p className={`pt-4 pb-6 text-3xl italic text-center capitalize font-semibold ${invoice.status === 'open' ? 'text-orange-500' : invoice.status === 'paid' ? 'text-green-500' : 'text-gray-500'}`}>
                {invoice.status}
              </p>
            </div>
          </div>
          <div className="p-4 bg-slate-50 my-4 rounded">
            {invoice.lines.data.map((line) => (
              <div key={line.id} className="mb-4">
                <p className="text-sm font-medium text-gray-700">{line.description}</p>
                <p className="text-xs text-gray-500">Original Amount: {formatCurrency(line.price.unit_amount, line.currency)}</p>
                <p className="text-xs text-gray-500">Amount To Be Paid: {formatCurrency(line.amount, line.currency)}</p>
              </div>
            ))}
            <div className="mt-6">
              <p className="text-lg font-semibold text-gray-800">Total Amount to be Paid: {formatCurrency(totalAmount, invoice.currency)}</p>
            </div>
          </div> */}
          {showCheckButton && (
            <Button
              onClick={async () => {
                await checkStripeInvoice(invoice.id);
              }}
              className="w-full font-medium text-white bg-blue-500 hover:bg-blue-400 hover:text-white"
            >
              Check the payment status
            </Button>
          )}
        </div>
        <AlertDialogFooter className="flex justify-content px-4 py-3 lg:gap-1">
          <AlertDialogAction
            onClick={openPaymentLink}
            className="w-full font-medium text-white bg-background hover:bg-gray-800 hover:text-white"
          >
            Pay
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default ModalWaitPaymentUpgrade;